
declare global {
    interface Window { COMMERCE_VERSION: any; }
}

export const version = {
  version: '0.0.0',
  buildTimestamp: '1761756291274',
  buildGitRevision: 'e1e56b67d151f5e2a2f493ae0c5ee783c7aca87c'
};

window.COMMERCE_VERSION = version;

